/*@flow*/
import { useQuery } from '@apollo/react-hooks';
import type { DocumentNode } from 'graphql';

type Options = { variables?: Object };

export default function useCachedQuery(
  query: DocumentNode,
  opts?: Options,
  initValue = {}
): any {
  const res = useQuery(query, opts || {});
  if (res.data) return res;
  res.data = initValue;
  return res;
}
